import api from './api'

export const getCoupons = id => api.get(`/professional/${id}/get_coupons/`)

export const getCouponValue = ({ coupon }) => api.post('/get_coupon_value/', { coupon })

export const setCoupon = (id, coupon) => api.post(`/professional/${id}/set_coupon/`, coupon)
